import {
    DeepRequired,
    FieldErrors,
    FieldErrorsImpl,
    FieldName,
    FieldValues,
    UnPackAsyncDefaultValues,
} from "react-hook-form";
import { FieldValuesFromFieldErrors } from "@hookform/error-message";
import { CustomErrorMessage } from "components/fields/items/CustomErrorMessage";
import { Fragment, ReactNode } from "react";
import { HelperText } from "components/fields/items/HelperText";

export function ErrorMessageOrHelperText<T extends FieldValues>(props: {
    errors: FieldErrors<T>;
    name: FieldName<FieldValuesFromFieldErrors<Partial<FieldErrorsImpl<DeepRequired<UnPackAsyncDefaultValues<T>>>>>>;
    helperText?: string | ReactNode;
}) {
    const { name, errors, helperText } = props;

    const showHelperText = errors[name as keyof typeof errors] == null;

    return (
        <Fragment>
            {showHelperText && <HelperText text={helperText} />}
            <CustomErrorMessage errors={errors} name={name} />
        </Fragment>
    );
}
